var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location-alt",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.95867,2.99183a11.965,11.965,0,0,0-12,11.92987,11.83285,11.83285,0,0,0,.977,4.72211c1.82524,3.90582,11.11737,15.348,11.11737,15.348s8.42-10.26263,10.74189-15.08954A13.32336,13.32336,0,0,0,30.9587,14.9217,11.965,11.965,0,0,0,18.95867,2.99183Zm.00006,19.42231a7.77,7.77,0,1,1,0-15.53968,7.87541,7.87541,0,0,1,7.81543,7.76984A7.72842,7.72842,0,0,1,18.95873,22.41414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAlt);
export default __webpack_public_path__ + "static/media/location-alt.d4a6d5c8d687e99196231882c82f37f5.svg";
export { ForwardRef as ReactComponent };